import Color from 'color'

// Define a type for ColorState
export interface IndicationColorState {
  colorBgChecked: string
  colorBgUnchecked: string
  colorText: string
}

export function deriveIndicationColorState(
  primary: string
): IndicationColorState {
  const primaryColor = new Color(primary)
  return {
    colorBgChecked: primaryColor.hex(),
    colorBgUnchecked: primaryColor.darken(0.5).hex(),
    colorText: primaryColor.darken(-0.8).hex(),
  }
}

const UNKNOWN_PRIMARY_COLOR = '#b8b8b8'
export const UNKNOWN_COLOR_SCHEME = deriveIndicationColorState(
  UNKNOWN_PRIMARY_COLOR
)
